import React, { useEffect, useState } from 'react';
import { TbBrandWhatsapp, TbLocationFilled, TbMapPin, TbMapPinExclamation, TbMapPinFilled, TbPhone } from 'react-icons/tb';
import { formatDistance, formatPhone } from '../../Utils/Formatters';
import { useStoreContext } from '../../Contexts/StoreContext';
import Badge from './Badge';
import { formatAddressStore, storeIsOpenByOrderType } from '../../Utils/Helpers';
import { useOrderTypeContext } from '../../Contexts/OrderTypeContext';

interface CardStoreListProps {
    store: any;
    onClick: (store: any) => void;
}

const CardStoreList = ({store, onClick}: CardStoreListProps) => {

    const { currentStore } = useStoreContext();
    const { orderType } = useOrderTypeContext();
    const [isOpen, setIsOpen] = useState(false);
    const isCurrent = currentStore && currentStore.id === store.id;

    useEffect(() => {
        setIsOpen(storeIsOpenByOrderType(orderType, store));
    }, [orderType, store]);

    return (
        <section className={`
            relative flex flex-col w-full justify-between rounded-lg p-4 gap-2
            ring-1 cursor-pointer transition ease-in-out duration-200
            hover:text-custom-primary
            active:ring-2 active:ring-custom-primary md:hover:ring-2 md:hover:ring-custom-primary
            active:shadow-lg md:hover:shadow-lg
            ${isCurrent ? 'ring-2 ring-custom-primary' : ' ring-gray-100'}
            `}
            onClick={() => onClick(store)}
            >
            {isCurrent && 
                <Badge type='custom' className='absolute -right-0.5 -top-0.5 rounded-md rounded-tr-md rounded-t-none rounded-r-none text-xs capitalize'>Atual</Badge>
            }
            <div className='flex flex-row gap-2'>
                <div className='-mt-0.5 -ml-0.5'>
                    {isOpen
                        ? currentStore?.id === store.id ? <TbMapPinFilled size={25} className='text-custom-primary' /> : <TbMapPin size={25} />
                        : <TbMapPinExclamation size={25} className='text-shopfood-error' />
                    }
                </div>
                <div className='grid text-left w-full gap-1.5 text-sm'>
                    <span className={`text-base font-bold leading-5 ${isOpen && 'text-custom-primary'}`}>{store.name}</span>
                    <span className='text-gray-400 text-sm'>
                        { formatAddressStore(store) }
                    </span>
                    {store.distance && 
                        <div className='flex items-center flex-wrap gap-0.5 text-nowrap font-semibold'>
                            <TbLocationFilled /> { formatDistance(store.distance) } de distância
                        </div>
                    }
                    {(store.phone || store.phone_additional || store.whatsapp_number) &&
                        <div className='flex items-center flex-wrap gap-x-2'>
                            {store.phone && <span className='flex gap-0.5 items-center text-nowrap'><TbPhone /> { formatPhone(store.phone) }</span>}    
                            { store.phone_additional && <span className='flex gap-0.5 items-center text-nowrap'><TbPhone /> { formatPhone(store.phone_additional) }</span>  }
                            { store.whatsapp_number && <span className='flex gap-0.5 items-center text-nowrap'><TbBrandWhatsapp /> { formatPhone(store.whatsapp_number) }</span> }
                        </div>
                    }
                    <span className='flex items-center gap-0.5 text-gray-400'>
                        {isOpen ? 'Aberta' : 'Fechada'}
                    </span>
                </div>
            </div>
        </section>
    );
}

export default CardStoreList;
